// Shared fail-closed fetch helper (vvrm + later @repo/web3). Browser-safe — never
// imports ./server, so the Chainalysis key can't reach a client bundle.
import { SCREEN_ADDRESS_ROUTE, type ScreenedAddress, screenedAddressSchema } from '../index'

const failClosedResult: ScreenedAddress = {
  isAuthorized: false
}

export interface ScreenAddressClientInit extends RequestInit {
  endpoint?: string // override only for the Next basePath edge case
}

// Fails closed on any client error (unreachable route, non-2xx, parse, abort).
export async function screenAddress(
  address: string,
  init?: ScreenAddressClientInit
): Promise<ScreenedAddress> {
  const { endpoint = SCREEN_ADDRESS_ROUTE, ...requestInit } = init ?? {}
  try {
    const screeningResponse = await fetch(endpoint, {
      ...requestInit,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(requestInit.headers ?? {}) },
      body: JSON.stringify({ address })
    })
    if (!screeningResponse.ok) {
      return failClosedResult
    }
    // Validate the wire response: an unexpected shape (or invalid JSON, which
    // throws into the catch below) fails closed rather than trusting the cast.
    const parsed = screenedAddressSchema.safeParse(await screeningResponse.json())
    return parsed.success ? parsed.data : failClosedResult
  } catch {
    return failClosedResult
  }
}
